export type Lang = 'ar' | 'en';
export interface Bilingual {
  ar: string;
  en: string;
}

const STRINGS = {
  brand: { ar: 'دورِك', en: 'DOREK' },
  switchLang: { ar: 'English', en: 'عربي' },

  // customer ticket
  yourOrder: { ar: 'رقم طلبك', en: 'Your order' },
  yourTurnNumber: { ar: 'رقم دورك', en: 'Your number' },
  posRef: { ar: 'رقم الفاتورة', en: 'Receipt no.' },
  refQueue: { ar: 'المرجع', en: 'Reference' },
  goToCounter: { ar: 'توجّه إلى الكاونتر', en: 'Please come to the counter' },
  st_waiting_order: { ar: 'قيد التحضير', en: 'Being prepared' },
  st_waiting_queue: { ar: 'بالانتظار', en: 'Waiting' },
  st_called_order: { ar: 'طلبك جاهز', en: 'Your order is ready' },
  st_called_queue: { ar: 'حان دورك', en: "It's your turn" },
  st_serving: { ar: 'قيد الخدمة', en: 'Being served' },
  st_completed: { ar: 'اكتملت', en: 'Completed' },
  st_cancelled: { ar: 'أُلغيت', en: 'Cancelled' },
  st_no_show: { ar: 'لم يحضر', en: 'Missed' },
  st_expired: { ar: 'انتهت صلاحيتها', en: 'Expired' },
  aheadOfYou: { ar: 'أمامك', en: 'Ahead of you' },
  youAreNext: { ar: 'أنت التالي', en: "You're next" },
  goTo: { ar: 'توجّه إلى', en: 'Go to' },
  pickupAt: { ar: 'الاستلام من', en: 'Pick up at' },
  waitHint_order: { ar: 'خذ راحتك. بننبهك أول ما يجهز طلبك.', en: "Relax. We'll alert you the moment your order is ready." },
  waitHint_queue: { ar: 'خذ راحتك. بننبهك أول ما يحين دورك.', en: "Relax. We'll alert you when it's your turn." },
  // A phone on silent / Do Not Disturb can't be made to ring (owner request 2026-10-24): say so.
  alertTip: { ar: 'شغّل الصوت أو الهزّاز، وطفِّ «عدم الإزعاج»، عشان ما يفوتك النداء.', en: "Keep sound or vibration on and Do Not Disturb off, so you don't miss the call." },
  calledHint: { ar: 'تفضّل الآن', en: 'Please come now' },
  imComing: { ar: 'تم، أنا جاي', en: "Got it, I'm coming" },
  acknowledged: { ar: 'وصلنا تأكيدك', en: 'Thanks, noted' },
  recallBadge: { ar: 'تذكير', en: 'Reminder' },

  alertsTitle: { ar: 'خلّ جوالك ينبهك', en: 'Let your phone alert you' },
  alertsLead: { ar: 'اضغط الزر مرة واحدة لتفعيل التنبيه. ما نطلب رقمك ولا حساب.', en: 'Tap once to turn on alerts. No phone number or account needed.' },
  enableAlerts: { ar: 'فعّل التنبيه', en: 'Turn on alerts' },
  enabling: { ar: 'جارٍ التفعيل…', en: 'Turning on…' },
  testSound: { ar: 'جرّب الصوت', en: 'Test sound' },
  reEnableSound: { ar: 'اضغط لإعادة تفعيل الصوت', en: 'Tap to re-enable sound' },
  cap_sound: { ar: 'صوت داخل الصفحة', en: 'Sound on this page' },
  cap_push: { ar: 'إشعار والجوال مقفل', en: 'Notification when locked' },
  cap_wake: { ar: 'إبقاء الشاشة مضاءة', en: 'Keep screen on' },
  cap_vibrate: { ar: 'اهتزاز', en: 'Vibration' },
  cap_on: { ar: 'مفعّل', en: 'On' },
  cap_off: { ar: 'غير مفعّل', en: 'Off' },
  cap_unsupported: { ar: 'غير متاح هنا', en: 'Not available here' },
  cap_available: { ar: 'متاح (حسب الجهاز)', en: 'Available (device-dependent)' },
  cap_denied: { ar: 'مرفوض من الإعدادات', en: 'Blocked in settings' },
  cap_needs_homescreen: { ar: 'يحتاج إضافة للشاشة الرئيسية', en: 'Needs Add to Home Screen' },
  cap_error: { ar: 'تعذّر', en: 'Failed' },
  keepOpenNote: {
    ar: 'لأفضل نتيجة: أبقِ هذه الصفحة مفتوحة. إذا قفلت الجوال أو فتحت تطبيقاً آخر قد لا يصل الصوت.',
    en: 'Best result: keep this page open. If you lock the phone or switch apps, the sound may not play.',
  },
  pushOnNote: {
    ar: 'الإشعار مفعّل: يصلك تنبيه حتى لو قفلت الجوال، حسب إعدادات جوالك (الصامت والتركيز).',
    en: 'Notifications are on: you should be alerted even when locked, subject to your phone settings (silent, Focus).',
  },
  iosHomeTitle: { ar: 'تبي تنبيه والجوال مقفل؟ (آيفون)', en: 'Want alerts while locked? (iPhone)' },
  iosHomeSteps: {
    ar: '١) اضغط زر المشاركة ⬆️  ٢) «إضافة إلى الشاشة الرئيسية»  ٣) افتح «دورِك» من الشاشة الرئيسية واضغط «فعّل التنبيه».',
    en: '1) Tap Share ⬆️  2) "Add to Home Screen"  3) Open "DOREK" from your Home Screen and tap "Turn on alerts".',
  },
  pushDeniedHelp: {
    ar: 'الإشعارات مرفوضة لهذا الموقع. تقدر تفعّلها من إعدادات المتصفح، أو تبقي الصفحة مفتوحة.',
    en: 'Notifications are blocked for this site. Enable them in browser settings, or keep this page open.',
  },
  silentNote: { ar: 'تأكد إن صوت الجوال مو على الصامت.', en: 'Make sure your phone is not on silent.' },
  sumPush: { ar: '✓ التنبيه مفعّل. يصلك إشعار حتى والجوال مقفل.', en: '✓ Alerts are on. You will be notified even when the phone is locked.' },
  sumPage: { ar: '✓ التنبيه مفعّل ما دامت هذه الصفحة مفتوحة.', en: '✓ Alerts are on while this page stays open.' },
  sumPageIos: { ar: '✓ التنبيه مفعّل ما دامت هذه الصفحة مفتوحة. تبي تنبيهاً والجوال مقفل؟', en: '✓ Alerts are on while this page stays open. Want alerts while locked?' },
  sumPageDenied: { ar: '✓ التنبيه مفعّل ما دامت هذه الصفحة مفتوحة. الإشعارات مرفوضة من إعدادات الجوال.', en: '✓ Alerts are on while this page stays open. Notifications are blocked in your phone settings.' },
  sumStream: { ar: '✓ التنبيه مفعّل. بيرن جوالك حتى لو كانت الشاشة مقفلة.', en: '✓ Alerts are on. Your phone will ring even with the screen locked.' },
  streamKeepNote: { ar: 'إذا ضغطت «إيقاف» في بطاقة شاشة القفل يتوقف التنبيه؛ ارجع للصفحة لتشغيله.', en: 'Pressing pause on the lock-screen card stops alerts; return to this page to turn them on again.' },
  sumInterrupted: { ar: 'توقف التنبيه مؤقتاً لأن تطبيقاً آخر يشغّل صوتاً. اضغط لإعادته.', en: 'Alerts paused because another app is playing audio. Tap to resume.' },
  sumSoundOff: { ar: 'الصوت متوقف. اضغط لإعادة تفعيله.', en: 'Sound is off. Tap to turn it back on.' },
  showDetails: { ar: 'تفاصيل تقنية', en: 'Technical details' },
  hideDetails: { ar: 'إخفاء التفاصيل', en: 'Hide details' },
  cap_lockcard: { ar: 'بطاقة شاشة القفل + رنين والجوال مقفل (تجريبي)', en: 'Lock-screen card + ring while locked (experimental)' },
  lockcardNote: {
    ar: 'تجريبي: يشغّل بثاً صامتاً من دورِك (مثل الراديو). البطاقة لا تتغير والجوال مقفل، لكن عند النداء يرن الجوال من البث نفسه حتى لو كانت الشاشة مقفلة. يستهلك حوالي 7 ميجابايت بيانات في الساعة، وقد يوقف الموسيقى اللي تسمعها.',
    en: 'Experimental: plays a silent stream from DOREK (like radio). The card will not change while locked, but when you are called the phone rings from the stream itself even with the screen locked. Uses about 7 MB of data per hour and may pause music you are playing.',
  },
  lockcardOn: { ar: 'شغّل بطاقة شاشة القفل', en: 'Turn on lock-screen card' },
  lockcardOff: { ar: 'أوقف بطاقة شاشة القفل', en: 'Turn off lock-screen card' },
  lockcardLost: { ar: 'توقف البث. اضغط لإعادة تشغيله.', en: 'The stream stopped. Tap to restart it.' },
  noSoundHelp: {
    ar: 'إذا وصل الإشعار بلا صوت: تأكد أن زر الصامت الجانبي ليس مفعّلاً، ومن الإعدادات ← الإشعارات ← دورِك ← الأصوات.',
    en: 'If the notification arrives without sound: check the side silent switch, and Settings → Notifications → DOREK → Sounds.',
  },

  ended_completed: { ar: 'شكراً لزيارتك. انتهت المتابعة.', en: 'Thanks for your visit. Tracking has ended.' },
  ended_cancelled: { ar: 'أُلغيت هذه التذكرة. راجع الكاونتر إذا عندك استفسار.', en: 'This ticket was cancelled. Please ask at the counter.' },
  ended_no_show: { ar: 'تم تجاوز رقمك لعدم الحضور. راجع الكاونتر.', en: 'Your number was skipped as missed. Please ask at the counter.' },
  ended_expired: { ar: 'انتهت صلاحية هذه التذكرة.', en: 'This ticket has expired.' },
  notFoundTitle: { ar: 'الرابط غير صالح أو انتهى', en: 'This link is invalid or has expired' },
  notFoundBody: { ar: 'امسح رمز التذكرة من جديد أو اسأل الموظف.', en: 'Scan the ticket code again or ask the staff.' },

  conn_live: { ar: 'متصل', en: 'Live' },
  conn_reconnecting: { ar: 'يعاد الاتصال…', en: 'Reconnecting…' },
  conn_offline: { ar: 'لا يوجد اتصال بالإنترنت', en: 'No internet connection' },
  updatedAt: { ar: 'آخر تحديث', en: 'Updated' },

  // counter code (self-service: the customer takes a number like picking up a pager)
  counterTitle_order: { ar: 'خذ رقم طلبك', en: 'Take your order number' },
  counterTitle_queue: { ar: 'خذ دورك', en: 'Take a number' },
  counterLead_order: { ar: 'اضغط الزر، وسننبّه جوالك أول ما يجهز طلبك.', en: "Tap the button and we'll alert your phone the moment your order is ready." },
  counterLead_queue: { ar: 'اضغط الزر، وسننبّه جوالك أول ما يحين دورك.', en: "Tap the button and we'll alert your phone when it's your turn." },
  takeNumber: { ar: 'خذ رقمك', en: 'Take a number' },
  takingNumber: { ar: 'لحظة…', en: 'One moment…' },
  counterInvalid: { ar: 'هذا الرمز غير مفعّل. اسأل الموظف.', en: 'This code is not active. Please ask the staff.' },
  counterPushNote: { ar: 'سيطلب جوالك إذن التنبيهات مرة واحدة.', en: 'Your phone will ask once to allow notifications.' },
  counterFailed: { ar: 'تعذّر أخذ رقم. حاول مرة أخرى.', en: 'Could not take a number. Please try again.' },

  // test servers only: an iPhone on this web page is not testing the App Clip
  webPathTitle: { ar: 'هذه صفحة الويب، لا الـApp Clip', en: 'This is the web page, not the App Clip' },
  webPathBody: {
    ar: 'كاميرا الآيفون تفتح سفاري لأن الـApp Clip لم يُنشر في App Store بعد. سفاري يتوقف إذا فتحت تطبيقاً فيه صوت (مثل تيك توك). لاختبار الحل الجذري: TestFlight ← DOREK ← قسم App Clip.',
    en: "The iPhone camera opens Safari because the App Clip isn't on the App Store yet. Safari stops if you open an app that plays sound (like TikTok). To test the real solution: TestFlight → DOREK → App Clip section.",
  },

  // demo self-call (local/test servers only)
  demoTitle: { ar: 'تجربة النداء', en: 'Test the call' },
  demoLead: { ar: 'اضغط، ثم اقفل الجوال. سيناديك النظام بعد 20 ثانية.', en: 'Tap, then lock your phone. You will be called in 20 seconds.' },
  demoCall: { ar: 'نادني بعد 20 ثانية', en: 'Call me in 20 seconds' },
  demoCountdown: { ar: 'اقفل الجوال الآن… النداء خلال', en: 'Lock your phone now… calling in' },
  demoFailed: { ar: 'تعذّر جدولة النداء', en: 'Could not schedule the call' },

  // staff console
  staffTitle: { ar: 'تسجيل الدخول', en: 'Sign in' },
  staffSubtitle: { ar: 'للموظفين وأصحاب المحلات', en: 'For staff and business owners' },
  pagerNumber: { ar: 'رقم الطلب', en: 'Order no.' },
  pagerReady: { ar: 'جاهز', en: 'Ready' },
  pagerCall: { ar: 'نادِ', en: 'Call' },
  pagerNotFound: { ar: 'لا توجد تذكرة مفتوحة بهذا الرقم', en: 'No open ticket with that number' },
  tilesTitle_order: { ar: 'أو اضغط الرقم عندما يجهز:', en: 'Or tap a number when it is ready:' },
  tilesTitle_queue: { ar: 'أو اضغط رقماً لندائه:', en: 'Or tap a number to call it:' },
  tilesEmpty: { ar: 'لا أحد بالانتظار', en: 'No one waiting' },
  ind_livecard: { ar: 'بطاقة شاشة القفل', en: 'Lock-screen card' },
  counterQr: { ar: 'رمز الكاونتر', en: 'Counter code' },
  counterQrHint: { ar: 'اطبعه وألصقه عند الكاونتر. العميل يمسحه ويأخذ رقمه بنفسه، وأنت تضغط «جاهز» عندما يجهز.', en: 'Print it and place it at the counter. Customers scan it to take a number; you tap Ready when it is.' },
  counterOn: { ar: 'اللافتة تعمل: العملاء يأخذون أرقامهم بأنفسهم.', en: 'The sign is on: customers take their own numbers.' },
  counterOff: { ar: 'اللافتة مطفأة: العملاء لا يستطيعون أخذ رقم منها.', en: "The sign is off: customers can't take a number from it." },
  counterTurnOff: { ar: 'أطفئ اللافتة', en: 'Switch the sign off' },
  counterTurnOn: { ar: 'شغّل اللافتة', en: 'Switch the sign on' },
  counterOffConfirm: { ar: 'إطفاء اللافتة يمنع العملاء من أخذ أرقام منها حتى تشغّلها. متأكد؟', en: "Switching the sign off stops customers taking numbers from it until it's back on. Sure?" },
  switchedOffBy: { ar: 'أطفأه', en: 'Turned off by' },
  switchedOnBy: { ar: 'شغّله', en: 'Turned on by' },
  counterOffBanner: { ar: 'رمز الكاونتر مطفأ: العملاء لا يستطيعون أخذ رقم من اللافتة.', en: "The counter code is off: customers can't take a number from the sign." },
  turnOnNow: { ar: 'شغّله الآن', en: 'Turn it on' },
  today: { ar: 'اليوم', en: 'Today' },
  email: { ar: 'البريد', en: 'Email' },
  password: { ar: 'كلمة المرور', en: 'Password' },
  changePassword: { ar: 'كلمة المرور', en: 'Password' },
  changePasswordTitle: { ar: 'تغيير كلمة المرور', en: 'Change password' },
  currentPassword: { ar: 'كلمة المرور الحالية', en: 'Current password' },
  newPassword: { ar: 'كلمة المرور الجديدة (10 أحرف على الأقل)', en: 'New password (at least 10 characters)' },
  confirmPassword: { ar: 'أعد كتابة الجديدة', en: 'Repeat the new password' },
  savePassword: { ar: 'غيّر كلمة المرور', en: 'Change password' },
  pwChanged: { ar: 'تغيّرت كلمة المرور، وخرجت من الأجهزة الأخرى.', en: 'Password changed; other devices were signed out.' },
  pwWrong: { ar: 'كلمة المرور الحالية غير صحيحة.', en: 'The current password is wrong.' },
  pwSame: { ar: 'اختر كلمة مرور مختلفة عن الحالية.', en: 'Choose a password different from the current one.' },
  pwPublic: { ar: 'هذه كلمة مرور التجربة المنشورة؛ اختر غيرها.', en: 'That is the published demo password; choose another.' },
  showPassword: { ar: 'أظهر كلمة المرور', en: 'Show password' },
  hidePassword: { ar: 'أخفِ كلمة المرور', en: 'Hide password' },
  pwRules: { ar: 'كلمة المرور الجديدة 10 أحرف على الأقل.', en: 'The new password needs at least 10 characters.' },
  pwMismatch: { ar: 'الكلمتان الجديدتان غير متطابقتين.', en: 'The two new passwords don’t match.' },
  forgotHint: { ar: 'نسيت كلمة المرور؟ الموظف: اطلب من صاحب المحل أو المدير «كلمة مرور جديدة» من «إدارة المحل».', en: 'Forgot your password? Staff: ask the owner or a manager for a new one from "Manage business".' },
  forgotOwner: { ar: 'صاحب المحل: تواصل مع دعم دورِك', en: 'Business owners: contact DOREK support' },
  forgotByEmail: { ar: 'نسيت كلمة المرور؟ أرسل لي رابط على الإيميل', en: 'Forgot your password? Email me a link' },
  resetAskTitle: { ar: 'رابط تغيير كلمة المرور', en: 'Reset your password' },
  resetAskLead: { ar: 'اكتب إيميل حسابك، ونرسل لك رابط تختار منه كلمة مرور جديدة. الرابط صالح 30 دقيقة.', en: 'Type your account’s email and we’ll send a link to choose a new password. It works for 30 minutes.' },
  resetSend: { ar: 'أرسل الرابط', en: 'Send the link' },
  resetSentTitle: { ar: 'شيّك إيميلك', en: 'Check your email' },
  resetSentLead: {
    ar: 'إذا الإيميل مسجّل عندنا، بيوصلك رابط خلال دقائق. ما وصل؟ شيّك البريد غير المرغوب، أو اطلب «كلمة مرور جديدة» من صاحب المحل أو المدير.',
    en: 'If the email has an account, a link arrives within minutes. Nothing? Check your spam folder, or ask the owner or a manager for a new password.',
  },
  backToSignIn: { ar: 'رجوع لتسجيل الدخول', en: 'Back to sign-in' },
  resetNewTitle: { ar: 'اختر كلمة مرور جديدة', en: 'Choose a new password' },
  resetNewLead: { ar: 'بعدها تطلع كل الأجهزة من حسابك، وتدخل بالكلمة الجديدة.', en: 'Every device is then signed out, and you sign in with the new one.' },
  resetDone: { ar: 'تغيّرت كلمة المرور. ادخل بالجديدة.', en: 'Password changed. Sign in with the new one.' },
  resetLinkInvalid: { ar: 'الرابط انتهى أو انستخدم قبل. اطلب رابط جديد.', en: 'This link expired or was already used. Ask for a new one.' },
  resetAskAgain: { ar: 'اطلب رابط جديد', en: 'Ask for a new link' },
  ownPasswordTitle: { ar: 'اختر كلمة مرور خاصة فيك', en: 'Choose your own password' },
  ownPasswordLead: {
    ar: 'دخلت بكلمة مرور أعطاك إياها غيرك. اختر كلمة مرور خاصة فيك (10 أحرف على الأقل) قبل ما تكمل.',
    en: 'You signed in with a password someone gave you. Choose your own (at least 10 characters) before you go on.',
  },
  login: { ar: 'دخول', en: 'Sign in' },
  rememberDevice: { ar: 'تذكرني على هذا الجهاز (30 يوماً) — لجهاز الكاونتر فقط', en: 'Remember me on this device (30 days) — counter device only' },
  logout: { ar: 'خروج', en: 'Sign out' },
  loginFailed: { ar: 'بيانات الدخول غير صحيحة', en: 'Wrong email or password' },
  newTicket: { ar: 'تذكرة جديدة', en: 'New ticket' },
  originCounter: { ar: 'من لافتة الكاونتر', en: 'From the counter sign' },
  originStaff: { ar: 'من هذه الشاشة', en: 'Made on this screen' },
  twoWaysHint: {
    ar: 'العملاء يأخذون أرقامهم بأنفسهم من لافتة الكاونتر. «تذكرة جديدة» لعميل يطلب منك رقماً فقط: يمسح الرمز الذي يظهر هنا، لا لافتة الكاونتر (وإلا أخذ رقماً آخر).',
    en: 'Customers take their own numbers from the counter sign. Use "New ticket" only for a customer who asks you: they scan the code shown here, not the counter sign (that would give them another number).',
  },
  posRefOptional: { ar: 'رقم الفاتورة (اختياري)', en: 'Receipt no. (optional)' },
  posRefRequired: { ar: 'رقم الفاتورة', en: 'Receipt no.' },
  posRefNeeded: { ar: 'اكتب رقم الفاتورة أولاً.', en: 'Enter the receipt number first.' },
  numberInUse: { ar: 'الرقم {n} مفتوح من {t} في نفس الشفت. تأكد من رقم الفاتورة، وإذا الطلب القديم خلص اقفله من اللوحة وجرّب مرة ثانية.', en: 'Number {n} has been open since {t}, in this shift. Check the receipt number; if the old order is done, close it on the board and try again.' },
  offlineRetrying: { ar: 'لا يوجد اتصال بالإنترنت. نحاول مرة ثانية…', en: 'No internet connection. Trying again…' },
  counterOffline: { ar: 'تعذّر الاتصال. تأكد من الإنترنت، ونحاول مرة ثانية…', en: 'Can’t connect. Check your internet; trying again…' },
  displayConnecting: { ar: 'جارٍ الاتصال…', en: 'Connecting…' },
  retryNow: { ar: 'حاول الآن', en: 'Try now' },
  themeDark: { ar: 'الوضع الليلي', en: 'Dark mode' },
  themeLight: { ar: 'الوضع النهاري', en: 'Light mode' },
  shift_morning: { ar: 'شفت صباحي', en: 'Morning shift' },
  shift_evening: { ar: 'شفت مسائي', en: 'Evening shift' },
  shift_night: { ar: 'شفت ليلي', en: 'Night shift' },
  numberReplaced: { ar: 'الرقم {n} كان مفتوحاً من {t} (شفت قبل)، وانقفل تلقائياً.', en: 'Number {n} had been open since {t} (an earlier shift); it was closed automatically.' },
  h_expired_reused: { ar: 'انقفلت تلقائياً: نفس الرقم انعطى لطلب جديد', en: 'Closed automatically: the number went to a new order' },
  refQueueOptional: { ar: 'رقم الملف أو الحجز (اختياري)', en: 'File or booking no. (optional)' },
  callNext: { ar: 'نادِ التالي', en: 'Call next' },
  servicePoint: { ar: 'نقطة الخدمة', en: 'Service point' },
  noOneWaiting: { ar: 'لا يوجد أحد بالانتظار', en: 'Nobody is waiting' },
  col_waiting_order: { ar: 'قيد التحضير', en: 'Preparing' },
  col_waiting_queue: { ar: 'بالانتظار', en: 'Waiting' },
  col_called: { ar: 'تم النداء', en: 'Called' },
  col_serving: { ar: 'قيد الخدمة', en: 'Serving' },
  col_closed: { ar: 'أُغلقت مؤخراً', en: 'Recently closed' },
  closedAt: { ar: 'أُغلقت', en: 'Closed' },
  closedHint: { ar: 'المقفولة تبقى هنا لين يبدأ أول شفت في اليوم اللي بعده، وكلها محفوظة في سجل المحل.', en: 'Closed numbers stay here until the first shift of the next day starts; all are kept in the business’s log.' },
  act_call_order: { ar: 'جاهز — نادِ', en: 'Ready — call' },
  act_call_queue: { ar: 'نادِ', en: 'Call' },
  act_recall: { ar: 'إعادة النداء', en: 'Call again' },
  act_serve: { ar: 'بدء الخدمة', en: 'Start service' },
  act_complete_order: { ar: 'تم الاستلام', en: 'Picked up' },
  act_complete_queue: { ar: 'إنهاء', en: 'Finish' },
  act_cancel: { ar: 'إلغاء', en: 'Cancel' },
  act_no_show: { ar: 'لم يحضر', en: 'No-show' },
  act_requeue: { ar: 'تجاوز (لآخر الدور)', en: 'Skip (to end)' },
  confirmCancel: { ar: 'إلغاء هذه التذكرة؟', en: 'Cancel this ticket?' },
  confirmNoShow: { ar: 'تسجيل عدم حضور؟', en: 'Mark as no-show?' },
  qrWaitingScan: { ar: 'بانتظار مسح العميل…', en: 'Waiting for the customer to scan…' },
  qrScanned: { ar: '✓ فتح العميل التذكرة', en: '✓ Customer opened the ticket' },
  confirmUnscanned: {
    ar: 'التذكرة {n} لم يفتحها أحد بعد.\nموافق = إنشاء تذكرة جديدة\nإلغاء = عرض رمز التذكرة {n} مرة ثانية',
    en: "Ticket {n} hasn't been opened yet.\nOK = create a new ticket\nCancel = show ticket {n}'s code again",
  },
  scanToFollow: { ar: 'اطلب من العميل مسح الرمز بكاميرا جواله', en: 'Ask the customer to scan with their phone camera' },
  copyLink: { ar: 'نسخ الرابط', en: 'Copy link' },
  openLink: { ar: 'فتح', en: 'Open' },
  printSign: { ar: 'اطبع اللافتة', en: 'Print sign' },
  ownerConsole: { ar: 'لوحة المالك', en: 'Owner console' },
  manageBusiness: { ar: 'إدارة المحل', en: 'Manage business' },
  help: { ar: 'مساعدة', en: 'Help' },
  copied: { ar: 'تم النسخ', en: 'Copied' },
  close: { ar: 'إغلاق', en: 'Close' },
  showQr: { ar: 'عرض الرمز', en: 'Show QR' },
  history: { ar: 'السجل', en: 'History' },
  // A ticket's history, in plain words (staff/history.ts)
  // The trailing RLM keeps a closing bracket after the Latin words on the Arabic side.
  dev_ios_clip: { ar: 'آيفون — App Clip\u200f', en: 'iPhone — App Clip' },
  dev_ios_app: { ar: 'آيفون — التطبيق', en: 'iPhone — app' },
  dev_android: { ar: 'أندرويد', en: 'Android' },
  dev_browser: { ar: 'المتصفح', en: 'browser' },
  h_someone: { ar: 'موظف', en: 'staff' },
  h_created_staff: { ar: 'أنشأ التذكرة: {name}', en: 'Ticket made by {name}' },
  h_created_counter: { ar: 'أخذ العميل الرقم من لافتة الكاونتر', en: 'The customer took a number from the counter sign' },
  h_opened: { ar: 'العميل فتح التذكرة', en: 'The customer opened the ticket' },
  h_subscribed: { ar: 'تفعّل التنبيه على جوال العميل ({device})', en: 'Alerts on for the customer ({device})' },
  h_called: { ar: 'نادى {name} — النداء {n}', en: '{name} called — call {n}' },
  h_called_auto: { ar: 'نداء آلي — النداء {n}', en: 'Automatic call — call {n}' },
  h_recalled: { ar: 'أعاد {name} النداء — النداء {n}', en: '{name} called again — call {n}' },
  h_recalled_auto: { ar: 'أعاد النظام النداء تلقائياً — النداء {n}', en: 'Called again automatically — call {n}' },
  h_ack: { ar: 'العميل ضغط «تم، أنا جاي»', en: 'The customer tapped “I’m coming”' },
  h_serving: { ar: 'بدأت الخدمة: {name}', en: 'Service started by {name}' },
  h_completed_order: { ar: 'تم الاستلام: {name}', en: 'Picked up — {name}' },
  h_completed_queue: { ar: 'انتهت الخدمة: {name}', en: 'Finished — {name}' },
  h_completed_auto: { ar: 'انتهت تلقائياً', en: 'Closed automatically' },
  h_cancelled: { ar: 'أُلغيت: {name}', en: 'Cancelled by {name}' },
  h_no_show: { ar: 'لم يحضر: سجّله {name}', en: 'Missed — marked by {name}' },
  h_requeued: { ar: 'تجاوز لآخر الدور: {name}', en: 'Moved to the end of the line by {name}' },
  h_expired: { ar: 'انتهت صلاحيتها', en: 'Expired' },
  h_alert: { ar: 'التنبيه', en: 'Alert' },
  h_card: { ar: 'بطاقة شاشة القفل', en: 'Lock-screen card' },
  h_sent_ok: { ar: 'أُرسل ✓', en: 'sent ✓' },
  h_card_ok: { ar: 'تحدّثت ✓', en: 'updated ✓' },
  h_sending: { ar: 'قيد الإرسال…', en: 'sending…' },
  h_retrying: { ar: 'يعيد المحاولة…', en: 'retrying…' },
  h_failed: { ar: 'فشل ✗', en: 'failed ✗' },
  h_failed_gone: { ar: 'فشل ✗ (الجهاز لم يعد يستقبل)', en: 'failed ✗ (the device no longer accepts alerts)' },
  h_skipped_setup: { ar: 'لم يُرسل (خدمة الإشعارات غير مضبوطة)', en: 'not sent (push service not set up)' },
  h_skipped_off: { ar: 'لم يُرسل (التنبيه متوقف على الجهاز)', en: 'not sent (alerts off on the device)' },
  h_got_push: { ar: 'وصل تنبيه النداء {n} للجوال', en: 'Call {n} alert reached the phone' },
  h_got_hidden: { ar: 'وصل النداء {n} للتطبيق وهو في الخلفية', en: 'Call {n} reached the app in the background' },
  h_seen: { ar: 'ظهر النداء {n} على شاشة العميل', en: 'Call {n} showed on the customer’s screen' },
  displayScreen: { ar: 'شاشة الانتظار', en: 'Waiting screen' },
  displayScanTitle: { ar: 'امسح وخذ رقمك', en: 'Scan to take a number' },
  displayScanLead_order: { ar: 'وننبّه جوالك أول ما يجهز طلبك', en: 'We’ll alert your phone when your order is ready' },
  displayScanLead_queue: { ar: 'وننبّه جوالك أول ما يحين دورك', en: 'We’ll alert your phone when it’s your turn' },
  displayLinkHint: { ar: 'افتح هذا الرابط على التلفزيون أو التابلت المعروض للعملاء. لا يحتاج تسجيل دخول.', en: 'Open this link on the TV or tablet customers see. No sign-in needed.' },
  // The customer screen (owner, 2026-11-03): a tablet facing the customer shows each new number's code.
  customerScreen: { ar: 'شاشة الزبون', en: 'Customer screen' },
  customerScreenHint: {
    ar: 'تابلت على الكاونتر مقابل الزبون: كل تذكرة تسويها يطلع رمزها عليه لحاله، والزبون يمسحه بجواله، فما تحتاج تلف شاشتك. امسح هذا الرمز بكاميرا التابلت أو افتح الرابط فيه. لا يحتاج تسجيل دخول.',
    en: 'A tablet on the counter facing the customer: each ticket you make shows its code there by itself and the customer scans it, so you never turn your screen round. Scan this code with the tablet’s camera, or open the link on it. No sign-in needed.',
  },
  customerScreenUse: { ar: 'رمز التذكرة يطلع على شاشة الزبون، بدون نافذة على شاشتي', en: 'Show the ticket’s code on the customer screen, with no window on my screen' },
  customerScreenNote: { ar: 'يُحفظ لهذا الجهاز فقط. «عرض الرمز» على أي تذكرة يفتح نافذتها هنا متى ما احتجت.', en: 'Kept for this device only. “Show QR” on any ticket still opens its window here when needed.' },
  onCustomerScreen: { ar: 'رقم {n}: رمزه على شاشة الزبون', en: 'Number {n}: its code is on the customer screen' },
  customerScreenDown: { ar: 'شاشة الزبون مو شغالة الحين (مطفية أو بدون إنترنت)، فطلع الرمز هنا.', en: 'The customer screen isn’t on right now (off or offline), so the code is shown here.' },
  waitFor: { ar: 'انتظر', en: 'Wait' },
  seconds: { ar: 'ثانية', en: 's' },
  ind_opened: { ar: 'فتح الصفحة', en: 'Opened' },
  ind_live: { ar: 'متصل الآن', en: 'Live now' },
  ind_stream: { ar: 'الجوال يستمع', en: 'Phone listening' },
  ind_push: { ar: 'إشعار', en: 'Push' },
  ind_accepted: { ar: 'قُبل الإرسال', en: 'Sent' },
  ind_device: { ar: 'وصل للجهاز', en: 'On device' },
  ind_page: { ar: 'ظهر بالصفحة', en: 'On page' },
  ind_ack: { ar: 'أكّد العميل', en: 'Confirmed' },
  ind_failed: { ar: 'فشل الإرسال', en: 'Send failed' },
  ind_pending: { ar: 'قيد الإرسال', en: 'Sending' },
  ind_nochannel: { ar: 'لا توجد قناة تنبيه — نادِ بالصوت', en: 'No alert channel — call out loud' },
  minutesShort: { ar: 'د', en: 'm' },
  justNow: { ar: 'الآن', en: 'now' },
  error_generic: { ar: 'حدث خطأ، حاول مرة أخرى', en: 'Something went wrong, try again' },

  // display
  nowCalling: { ar: 'يُنادى الآن', en: 'Now calling' },
  preparing: { ar: 'قيد التحضير', en: 'Preparing' },
  waitingCount: { ar: 'بالانتظار', en: 'Waiting' },
  noCallsYet: { ar: 'لا نداء الآن', en: 'No one is being called' },
  enableDisplaySound: { ar: 'تفعيل صوت الشاشة', en: 'Enable screen sound' },
} satisfies Record<string, Bilingual>;

export type StringKey = keyof typeof STRINGS;

export function t(key: StringKey, lang: Lang): string {
  return STRINGS[key][lang];
}

export function pick(text: Bilingual | null | undefined, lang: Lang): string {
  return text ? text[lang] : '';
}

const LANG_KEY = 'dorek.lang';

export function initialLang(): Lang {
  try {
    const saved = localStorage.getItem(LANG_KEY);
    if (saved === 'ar' || saved === 'en') return saved;
  } catch {
    /* storage unavailable */
  }
  return navigator.language?.toLowerCase().startsWith('ar') ? 'ar' : navigator.language ? 'en' : 'ar';
}

export function applyLang(lang: Lang): void {
  document.documentElement.lang = lang;
  document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
  try {
    localStorage.setItem(LANG_KEY, lang);
  } catch {
    /* ignore */
  }
}
